import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41efaa03&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=41efaa03&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41efaa03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41efaa03')) {
      api.createRecord('41efaa03', component.options)
    } else {
      api.reload('41efaa03', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41efaa03&scoped=true", function () {
      api.rerender('41efaa03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/workbench/components/index.vue"
export default component.exports